<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="dateFormatted"
        :rules="rules"
        :label="label"
        hint="dia / mes / año"
        persistent-hint
        prepend-icon="event"
        v-bind="attrs"
        :readonly="readonly"
        @blur="date = parseDate(dateFormatted)"
        v-on="readonly ? '' : on"
      ></v-text-field>
    </template>
    <v-date-picker
      ref="picker"
      v-model="date"
      no-title
      @input="menu = false"
      :min="min"
      :max="max"
    ></v-date-picker>
  </v-menu>
</template>
<script>
import moment from "moment";

export default {
  props: {
    label: { type: String, default: "Seleccione una fecha" },
    fecha: { type: String, default: "" },
    min: { type: String, default: "2000-01-01" },
    max: { type: String, default: new Date().toISOString().substr(0, 10) },
    rules: { type: Array },
    format: {type: String, default: 'YMD'},
    readonly: {type: Boolean, default: false},
  },
  data() {
    return {
      dateFormatted: "",
      menu: false,
      date: "",

    };
  },
  mounted() {
    if (this.fecha) {
      this.dateFormatted = this.fecha;
    }
  },
  methods: {
    parseDate(date) {
      
      if (!date) return null;

      if (!moment(date, "DD/MM/YYYY", false).isValid()) {
        this.date = null;
        return null;
      }

      this.menu = false;

      const [day, month, year] = date.split("/");

      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;

    },
    formatDate(date) {
      
      if (!date) return null;
      
      if (!moment(date, "YYYY-MM-DD", true).isValid()) {
        this.date = null;
        return null;
      }

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
  },
  watch: {
    date() {
      if (this.date) {
        this.dateFormatted = this.formatDate(this.date);
      }
      if (this.format =='YMD') {
        this.$emit("fecha", this.date);
      } else if (this.format =='DMY') {
        this.$emit("fecha", this.dateFormatted);
      }
    },
    menu(val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },
};
</script>